<!--
 * @Description: 二次认证
-->

<template>
  <div class="perfect_info">
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>

    <div class="box-title">
      <Icon name="info-o" size="16" style="margin-right: 5px" />
      {{ $t("login.second_auth.tip") }}
    </div>

    <Form class="vertical_self_form" @submit="onSubmit">
      <Field
        prop="type"
        v-model="typeName"
        name="type"
        :label="$t('login.second_auth.label')"
        :placeholder="$t('login.second_auth.placeholder')"
        @click="showAuth = true"
      >
      </Field>
      <template v-if="form.type == 1">
        <Field readonly prop="sjh" v-model="mobile" name="sjh" :label="$t('base.mobile.label')"> </Field>
        <Field
          v-model="form.value"
          name="code"
          :label="$t('base.captcha.label')"
          :placeholder="$t('base.captcha.placeholder')"
          :show-error-message="false"
          :scroll-to-error="true"
          :rules="[{ required: true }]"
        >
          <template #button>
            <Button v-if="count == 60" size="small" color="#ff9800" plain @click="handleCode(2)">{{
              $t("base.btn.get_code")
            }}</Button>
            <Button v-else disabled size="small" color="#ff9800" plain> {{ count }}s </Button>
          </template>
        </Field>
      </template>
      <!-- <template v-if="form.type == 2">
        <Field
          prop="wxh"
          v-model="form.wxh"
          name="wxh"
          label="企业微信号"
          placeholder="请输入企业微信号"
        >
        </Field>
      </template>
      <template v-if="form.type == 3">
        <Field
          prop="rlsb"
          v-model="form.rlsb"
          name="rlsb"
          label="支付宝人脸识别"
          placeholder="请输入支付宝人脸识别"
        >
        </Field>
      </template> -->
      <template v-if="form.type == 4">
        <Field
          prop="password"
          v-model="form.value"
          name="password"
          :label="$t('login.second_auth.password_label')"
          :placeholder="$t('login.second_auth.password_placeholder')"
          :show-error-message="false"
          :scroll-to-error="true"
          :rules="[{ required: true }]"
        >
        </Field>
      </template>
      <template v-if="form.type == 5">
        <Field readonly prop="email" v-model="email" name="email" :label="$t('base.email.label')"></Field>
        <Field
          v-model="form.value"
          name="captcha"
          :placeholder="$t('base.captcha.label')"
          :show-error-message="false"
          :scroll-to-error="true"
          :rules="[{ required: true, message: $t('base.captcha.placeholder') }]"
        >
          <template #button>
            <Button v-if="count == 60" size="small" color="#ff9800" plain @click="handleCode(1)">{{
              $t("base.btn.get_code")
            }}</Button>
            <Button v-else disabled size="small" color="#ff9800" plain> {{ count }}s </Button>
          </template>
        </Field>
      </template>
      <ActionSheet v-model="showAuth" :actions="authList" @select="selectChange"> </ActionSheet>
      <div style="margin: 30px 0">
        <Button round block type="info" native-type="submit">{{ $t("base.btn.sure") }}</Button>
        <Button round block style="margin-top: 10px" @click="goLogin">{{ $t("base.btn.back_login") }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Popup, Icon, Form, Field, Button, DatetimePicker, ActionSheet, NavBar } from "vant";
import { commonAPI } from "@/apis";
import { commonMethods } from "./mixins/common";
import { toast } from "@/utils/toast";

export default {
  name: "SecondAuth",
  components: { Popup, Icon, Form, Field, Button, DatetimePicker, ActionSheet, NavBar },
  mixins: [commonMethods],
  data() {
    return {
      form: { type: "1", value: "" },
      defaultAuth: [
        { value: "1", name: this.$t("login.second_auth.auth_list.one") },
        { value: "2", name: this.$t("login.second_auth.auth_list.two") },
        { value: "3", name: this.$t("login.second_auth.auth_list.three") },
        { value: "4", name: this.$t("login.second_auth.auth_list.four") },
        { value: "5", name: this.$t("login.second_auth.auth_list.five") },
      ],
      authList: [],
      mobile: "",
      email: "",
      showAuth: false,
      typeName: "",
      safeSetInfo: {},
      before_login: {},
      count: 60,
    };
  },
  created() {
    this.mobile = this.user.mobile;
    this.email = this.user.email;
    // 获取安全配置
    let safeSetInfo = sessionStorage.getItem("SAFE_SET_INFO");
    this.safeSetInfo = safeSetInfo ? JSON.parse(safeSetInfo) : {};

    // 判断是否浏览器回退前进进入
    let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
    if (!before_login || !before_login.secAuth) {
      this.$router.replace({ path: "/mlogin" });
    } else {
      this.before_login = { ...before_login };
    }

    this.defaultAuth.forEach((el) => {
      let flag = this.safeSetInfo.yxecrzfs.includes(el.value);
      if (flag) {
        this.authList.push(el);
      }
    });

    this.form.type = this.authList.length ? this.authList[0].value : undefined;
    this.typeName = this.authList.length ? this.authList[0].name : "";
  },
  methods: {
    // 获取验证码
    async handleCode(type) {
      let params = {
        noticeClassify: type,
        businessClassify: "sec_auth",
        account: type == 1 ? this.email : this.mobile,
      };
      const { code, message } = await commonAPI.getAction("send/msg/sendCaptcha", params);
      if (code == 0) {
        toast(message);
        // 开启倒计时
        this.count--;
        const timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        toast(message);
      }
    },
    // 切换认证方式
    selectChange(v) {
      this.form.type = v.value;
      this.typeName = v.name;
      this.showAuth = false;
      // 每次切换方式的时候需要清空数据
      for (var k in this.form) {
        if (k !== "type") {
          this.form[k] = "";
        }
      }
    },
    onSubmit() {
      let params = { classify: this.form.type, val: this.form.value };
      (async () => {
        const { code, message } = await commonAPI.postAction(`/users/secCertification/${this.user.username}`, params);
        if (code == 0) {
          toast(message);
          this.before_login.secAuth = false;
          sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
          this.jumpComputed();
        } else {
          toast(message);
        }
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

.flex {
  display: flex;
  align-items: center;
}
.box-title {
  background: #fff8ee;
  border: 1px solid rgba(255, 152, 0, 0.19);
  color: #ff9800;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  padding: 5px;
  @extend .flex;
}
</style>
